import React from 'react';
import LegalPage from './LegalPage';

export default function About() {
  return (
    <LegalPage title="About ClickSaver" updated="April 2026">

      <p>
        ClickSaver is a click fraud protection platform built for Google Ads advertisers. We help businesses
        protect their ad budgets by automatically detecting and blocking fraudulent clicks — bots, VPNs,
        proxies, and repeat offenders — before they drain your campaign spend.
      </p>

      <h2>What We Do</h2>
      <p>
        Every day, billions of fraudulent clicks waste advertising budgets worldwide. ClickSaver sits between
        your Google Ads campaigns and the fraudsters, analyzing every click in real time and blocking
        suspicious activity automatically.
      </p>
      <ul>
        <li><strong>Real-time fraud detection</strong> — Detect bots, VPNs, proxies, Tor exit nodes, and suspicious click patterns the moment they hit your ads.</li>
        <li><strong>Automatic IP blocking</strong> — Fraudulent IPs are blocked instantly and synced directly to your Google Ads IP exclusion lists via the Google Ads API.</li>
        <li><strong>Campaign-level protection</strong> — Each campaign is monitored independently with detailed fraud analytics and reporting.</li>
        <li><strong>Transparent reporting</strong> — Full visibility into every blocked IP, reason for blocking, and estimated savings.</li>
      </ul>

      <h2>How It Works</h2>
      <p>
        ClickSaver uses a tracking URL system — no JavaScript snippet required on your website. Simply replace
        your Google Ads destination URL with your ClickSaver tracking URL. Every click passes through
        ClickSaver's fraud detection engine before reaching your landing page. Fraudulent visitors are blocked
        and their IPs are automatically added to your Google Ads exclusion lists.
      </p>

      <h2>Our Mission</h2>
      <p>
        We believe every advertising dollar should work hard for your business. Click fraud costs advertisers
        billions annually. Our mission is to give every advertiser — from small businesses to enterprise brands
        — the tools to fight back and protect their ad spend.
      </p>

      <h2>Company Information</h2>
      <ul>
        <li><strong>Company Name:</strong> ClickSaver</li>
        <li><strong>Website:</strong> <a href="https://clicksaver.app">https://clicksaver.app</a></li>
        <li><strong>Address:</strong> 651 N Broad St, Suite 206, Middletown, DE 19709, United States</li>
        <li><strong>Email:</strong> <a href="mailto:support@clicksaver.app">support@clicksaver.app</a></li>
      </ul>

      <h2>Google Ads API Usage</h2>
      <p>
        ClickSaver integrates with the Google Ads API to automatically push blocked IP addresses to your
        campaign IP exclusion lists. We use the <code>campaignCriteria:mutate</code> endpoint to add fraudulent
        IPs as negative campaign criteria, preventing those visitors from seeing your ads in the future. We
        also use the Google Ads API to read campaign data and existing exclusions for reporting purposes.
      </p>
      <p>
        We request the <code>https://www.googleapis.com/auth/adwords</code> OAuth scope solely for the purpose
        of managing IP exclusions on behalf of our users. We do not use this access for any other purpose, and
        users may disconnect their Google Ads account at any time from the Settings page.
      </p>

      <h2>Contact Us</h2>
      <p>
        Have questions? We'd love to hear from you.
      </p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:support@clicksaver.app">support@clicksaver.app</a></li>
        <li><strong>Website:</strong> <a href="https://clicksaver.app/contact">https://clicksaver.app/contact</a></li>
        <li><strong>Address:</strong> 651 N Broad St, Suite 206, Middletown, DE 19709, United States</li>
      </ul>

    </LegalPage>
  );
}
